import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { OPTIONS_MASK } from 'src/app/core/constants/options-mask.constant';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { HelpersUtil } from '../../utils/helpers.util';

@Component({
  selector: 'app-valor-recebido-troco-dialog',
  templateUrl: './valor-recebido-troco-dialog.component.html',
  styleUrls: ['./valor-recebido-troco-dialog.component.scss']
})
export class ValorRecebidoTrocoDialogComponent implements OnInit {
  public readonly optionsMask = OPTIONS_MASK;
  
  // componentProps
  public valorAPagarEmReais: number;

  @ViewChild('valorRecebidoInp', { static: false }) private _valorRecebidoInp: ElementRef<HTMLInputElement>;

  public valorRecebido = 0;

  constructor(
    private _modalCtrl: ModalController
  ) { }

  public get troco() {
    if (!this.valorRecebido) return 0;

    return this.valorRecebido - this.valorAPagarEmReais;
  }

  public async cancelarAsyncOnClick() {
    await this._cancelarAsync();
  }

  public async confirmarAsyncOnClick() {
    await this._confirmarAsync();
  }

  public ngOnInit() {
    HelpersUtil.executeAfterDelay(() => this._valorRecebidoInp.nativeElement.focus());
  }

  @HostListener('document:keydown', ['$event'])
  private async _lidarComKeyboardEventAsync(event: KeyboardEvent) {
    switch (event.key) {
      case KeyboardKeysEnum.F5:
        event.preventDefault();
        event.stopPropagation();

        await this._confirmarAsync();
        break;
      case KeyboardKeysEnum.Escape:
        event.preventDefault();
        event.stopPropagation();

        await this._cancelarAsync();
        break;
    }
  }

  private async _cancelarAsync() {
    await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
  }

  private async _confirmarAsync() {
    await this._modalCtrl.dismiss(new ValorRecebidoTrocoDataClose(this.valorRecebido, this.troco), ModalRoleEnum.CONFIRM);
  }
}

export class ValorRecebidoTrocoDataClose {
  constructor(
    public valorRecebido: number,
    public troco: number
  ) { }
}
